module.exports = __webpack_public_path__ + "static/media/clbanner.cf529c4a.png";